import { type ReactElement, type ReactNode } from 'react';

export type Props = {
  children: ReactElement<{ children?: ReactNode }>;
};

export const Optional = ({ children }: Props) => (children.props.children ? children : undefined);
